import env from "../../utils/env";

let AuthService = function ($http, NavigationService) {
  "ngInject";

  let _accessToken;


  const setAccessToken = (response) => {
    window.localStorage.setItem("bigfootAccessToken", response.data.accessToken);
    window.localStorage.setItem("bigfootRefreshToken", response.data.refreshToken);
    _accessToken = response.data.accessToken;
  };

  const getAccessToken = () => {
    // Always retrieve from storage.
    // if (_accessToken) return _accessToken;

    var token = window.localStorage.getItem("bigfootAccessToken");
    if (token) _accessToken = token;

    return token;
  };

  const getRefreshToken = () => {
    var token = window.localStorage.getItem("bigfootRefreshToken");

    return token;
  };

  const refreshToken = () => {
    const payload = {
      refreshToken: getRefreshToken()
    };

    return $http({
      method: "POST",
      url: env.getApiUrl("identity/refreshtoken"),
      data: payload
    })
    .then((response) => {
      setAccessToken(response);

      return response;
    });
  };

  const initiateLogin = (payload, successCb, errorCb) => {
    $http({
      method: "POST",
      url: env.getApiUrl("identity/initiatetwofactorlogin"),
      data: payload
    })
    .then((response) => {
      setAccessToken(response);
      successCb(response);
    }, errorCb);
  };

  const login = (payload, successCb, errorCb) => {
    $http({
      method: "POST",
      url: env.getApiUrl("identity/token"),
      data: payload
    })
    .then((response) => {
      setAccessToken(response);
      successCb(response);
    }, errorCb);
  };

  const logout = () => {
    window.localStorage.removeItem("bigfootAccessToken");
    window.localStorage.removeItem("bigfootRefreshToken");
    NavigationService.go("login");
    window.location.reload();
  };

  const isAuthorized = () => {
    if(window.localStorage.getItem("bigfootAccessToken")) return true;

    return false;
  };

  return { isAuthorized, login, logout, getAccessToken, initiateLogin, refreshToken, getRefreshToken };
};

export default AuthService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/auth.service.js
 **/